import { svgIcon } from "../icon-service";

export const BackgroundLeftIllustration = svgIcon`
`;
